export default (data) => {
  return {
    event: 'promotionClick',
    ecommerce: {
      promoClick: {
        promotions: {
          'id': 'BETA 2.0',
          'name': ' MYB 2.0 ',
          'creative': data.creative,
          'position': ' MYB ',
        },
      },
    },
  };
};
